import { render } from "./viking-shield.vue?vue&type=template&id=3923f5dc"
import script from "./viking-shield.vue?vue&type=script&lang=js"
export * from "./viking-shield.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__